import { SectionMessage } from "@certn/cascadia-react";

import { CheckData } from "../../types";

interface Props {
  error: CheckData["check_has_ordering_error_for_customer_group"];
}

export function CheckCardError(props: Props) {
  const { error } = props;

  if (!error) {
    return null;
  }

  if (error.type === "warning") {
    return (
      <SectionMessage icon="warning" sectionTitle={error.title} type="warning">
        {error.message}
      </SectionMessage>
    );
  }

  return (
    <SectionMessage icon="warning" sectionTitle={error.title} type="danger">
      {error.message}
    </SectionMessage>
  );
}
